import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { UserActions } from '../../redux/actions';

export const useFetchUsers = () => {
  const dispatch = useAppDispatch();
  const users = useAppSelector(state => state.User.users);

  useEffect(() => {
    dispatch(UserActions.getUsers.saga());
  }, []);

  return users;
};
